import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ParamRechazoCobro } from '../models/param-rechazo-cobro.model';
import { ApiResponse } from '../../../model/interfaces/response';
import { DATA_SOURCE } from '../../../../environments/environment';
import { HttpController } from '../../../utils/HttpController';

@Injectable({
  providedIn: 'root'
})
export class ParamRechazoCobroService extends HttpController<any> {

  constructor(private readonly httpClient: HttpClient) {
    super(httpClient, 'rechazo-cobro');
  }

  /**
   * Obtiene los parámetros de rechazo de cobro
   * @returns Observable con los parámetros
   */
  getParametros(): Observable<ApiResponse<ParamRechazoCobro>> {
    return this.read<ParamRechazoCobro>({
      datasource: DATA_SOURCE.VDI,
      path: `${this._endpoint}/all`
    });
  }

  /**
   * Guarda nuevos parámetros de rechazo de cobro
   * @param parametros Datos a guardar
   * @returns Observable con la respuesta
   */
  guardarParametros(parametros: ParamRechazoCobro): Observable<ApiResponse<any>> {
    return this.create<ParamRechazoCobro, any>({
      datasource: DATA_SOURCE.VDI,
      path: `${this._endpoint}`,
      body: parametros
    });
  }

  /**
   * Actualiza los parámetros de rechazo de cobro existentes
   * @param parametros Datos a actualizar
   * @returns Observable con la respuesta
   */
  actualizarParametros(parametros: ParamRechazoCobro): Observable<ApiResponse<any>> {
    return this.update<ParamRechazoCobro, any>({
      datasource: DATA_SOURCE.VDI,
      path: `${this._endpoint}`,
      body: parametros
    });
  }

  /**
   * Ejecuta el proceso de rechazo de cobro
   * @returns Observable con la respuesta de la ejecución
   */
  ejecutarRechazo(): Observable<ApiResponse<any>> {
    return this.read<any>({
      datasource: DATA_SOURCE.VDI,
      path: `${this._endpoint}/ejecutar`
    });
  }
}
